//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'

import PublicService from '@/service/public'

import TopFilter from '@/components/buildings_top_filter/index'


import HouseItem from '@/components/business/house_item'
import StatusTip from '@/components/views/status_tip'
import Search from './_search'
import TagFilter from './_tag_filter'
import EmptyBox from '@/components/views/empty_box'

import PageTopFilter from '@/common/mixins/page_top_filter'
import Pagination from '@/common/mixins/pagination'
import { BUILDING_STATUS } from '@/constant'

const RECOMMENT_TYPE = {
   '最新取证' : {
        filter_tabs: ['区域', '价格', '户型', '面积', '装修'],
        position: {
            list: 'latest_opening_list',
            banner: 'latest_opening_top_banner'
        },
        tags:  [
            {
                class_name: 'waiting',
                value: '即将登记',
                name: '即将登记'
            },
            {
                class_name: 'register',
                value: '正在登记',
                name: '正在登记'
            },
            {
                class_name: 'waiting-lottery',
                value: '等待摇号',
                name: '等待摇号'
            }
        ]
   },
   '最新摇号': {
        filter_tabs: ['区域', '价格', '户型', '面积', '装修'],
        tags: [
            {
                class_name: 'waiting-lottery',
                name: '等待摇号',
                value: '等待摇号'
            },
            {
                class_name: 'complete-lottery',
                name: '摇号完成',
                value: '摇号完成'
            }
        ]
    }
}


export default {
    mixins: [
        PageTopFilter,
        Pagination
    ],
    data () {
        return {
            tags: [],
            select_tag: '',
            zones: '',
            select_zones: [],
            position: null,
            filter_tabs: [],
            decoration: '',
            zone_ids: '',
            zone_section_ids: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            metro: '',
            keyword: '',
            type: '',
            recommendation: [],
            recommendation_tye: '',
            banner_loading: true,
            banner: [],
            no_more: false,
            feature: ''
        }
    },
    computed: {
        show_recommendation () {
            return [
                'decoration',
                'zone_ids',
                'zone_section_ids',
                'area',
                'total_price',
                'price',
                'layout',
                'metro'
            ].every(key => !this[key]) ||
                (this.recommendation_tye && this.recommendation_tye.list === 'zone_top_in_whole_list')
        }
    },
    created () {
        const { type, feature } = this.$route.query
        this.type = type
        this.feature = feature
        this.fetchData()
    },
    methods: {
        fetchData () {
            if (this.type !== '全部楼盘' && !this.feature) {
                const { position, filter_tabs, tags } = RECOMMENT_TYPE[this.type]
                this.filter_tabs = filter_tabs
                this.position = position
                this.tags = tags || []
                this.getData()
            }
        },
        getZones () {
            if (this.zones === '') {
                Service.getZones().then(data => {
                    this.select_zones = this.zones = data
                })
            }
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.page = 1
            this.resetList()
            this.getData()
        },
        resetList () {
            this.recommendation = []
            this.items = []
        },
        changeTag (value) {
            this.select_tag = value
            this.page = 1
            this.getData()
        },
        async getData () {
            this.loading = true
            const options = {
                page: this.page,
                name: this.keyword
            }
            let has_filter = false
            if (this.type !== '全部楼盘') {
                options.status = BUILDING_STATUS[this.type]
                if (this.select_tag) {
                    options.status = this.select_tag === '等待摇号' ? options.status + '-' + this.select_tag : this.select_tag
                }
                const filters = ['zone_ids', 'zone_section_ids', 'metro', 'area', 'price', 'total_price', 'layout', 'decoration']
                filters.forEach((key) => {
                    if (this[key]) {
                        options[key] = this[key]
                        has_filter = true
                    }
                })
            } else {
                if (this.select_zones && this.select_zones.length) {
                    options.zone_ids = this.select_zones.map(({ id }) => id).join(',')
                    has_filter = true
                }
            }
            if (this.show_recommendation) {
                options.exclude_ids = this.recommendation.map(({ building_id}) => building_id).join(',')
            }
            if (this.feature) {
                options.feature = this.feature
                this.filter_tabs = ['区域', '户型', '面积']
            }
            const data = await Service.getBuildings(options)
            this.handleData(data)
            this.$nextTick(this.checkTopFilterPosition)
        },
        checkTopFilterPosition () {
            if (this.page === 1) {
                window.scrollTo(0, 0)
            }
        },
        searchClick (keyword) {
            this.$router.push({
                name: 'search',
                query: {
                    type: this.type || ''
                }
            })
        }
    },
    components: {
        HouseItem,
        TopFilter,
        TagFilter,
        StatusTip,
        Search,
        EmptyBox
    }
}
